import { LoadType } from '@tencent/ark-extensions';

/**
 * 在线文档选择器-移动版
 */
export const DRIVE_SELECTOR_MOBILE = {
    name: 'docs-component-drive-selector-mobile',
    loadType: LoadType.ON_DEMAND,
};

/**
 * 在线文档选择器-PC版
 */
export const DRIVE_SELECTOR_PC = {
    name: 'docs-component-drive-selector-pc',
    loadType: LoadType.ON_DEMAND,
};

